import { Menu } from 'antd';
import { Menus } from './styles/menu.style';

export const IsoMenu = Menus(Menu);
export const IsoMenuItem = Menus(Menu.Item);
export const IsoMenuSubMenu = Menus(Menu.SubMenu);
